import { Box, type SxProps } from '@mui/material';
import { LinkBubbleMenu, RichTextEditor, TableBubbleMenu } from 'mui-tiptap';

import RichTextControls from '../RichTextControls/RichTextControls';
import RichTextExtensions from '../RichTextExtensions/RichTextExtensions';

type RichTextProps = {
  value?: string;
  onChange: (value: string) => void;
  formMode?: 'edit' | 'preview' | 'readonly' | 'new';
  sx?: SxProps;
};

export const RichText = ({ value, onChange, formMode = 'edit', sx }: RichTextProps) => {
  return (
    <Box sx={{ maxHeight: '350px', overflowY: 'scroll', ...sx }}>
      <RichTextEditor
        extensions={RichTextExtensions}
        editable={formMode !== 'preview'}
        content={value}
        onUpdate={({ editor }) => {
          const html = editor.getHTML();
          onChange(html);
        }}
        renderControls={() => (formMode === 'preview' ? null : <RichTextControls />)}
      >
        {() => (
          <>
            <LinkBubbleMenu />
            <TableBubbleMenu />
          </>
        )}
      </RichTextEditor>
    </Box>
  );
};

export default RichText;
